import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { CssBaseline, Container, Paper, Typography } from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { useGetStatsQuery } from '../../../store/apiSlice';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
}));

export function Stats(props) {
	const classes = useStyles();

	const { data } = useGetStatsQuery();
	console.log(data);

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Статистика</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Статистика
					</Typography>
					<br></br>

					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="simple table">
							<TableBody>
								<TableRow>
									<TableCell>Актуален брой потребители</TableCell>
									<TableCell>{data?.totalUsers}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Новорегистрирани потребители месечно</TableCell>
									<TableCell>{data?.newUsersMonthly}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Активни потребители през месеца</TableCell>
									<TableCell>{data?.activeUsersMonthly}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Актуален брой книги</TableCell>
									<TableCell>{data?.totalBooks}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Новокачени книги през месеца</TableCell>
									<TableCell>{data?.newBooksMonthly}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Общо брой посещения на сайта</TableCell>
									<TableCell>{data?.totalSiteVisits}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Paper>
			</Container>
		</div>
	);
}
